import {addAuthToFetchOpts} from '../config/queryopts'
import {useMutationWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";
import {useQueryClient} from "react-query";


export const DeleteTypoSquattingProjectFetcher = (accessToken, projectUid) => {
  return axios.delete(
    `${apiUrlInternal}/typosquatting_projects/${projectUid}`,
    addAuthToFetchOpts(accessToken, {})
  ).then(res => res.data);
}

export const useDeleteTypoSquattingProject = (fetcher = DeleteTypoSquattingProjectFetcher) => {
  const queryClient = useQueryClient();
  return useMutationWithAuthentication(
    ['delete-organization-typosquatting-project'],
    (accessToken, projectUid) => fetcher(accessToken, projectUid),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('delete-organization-typosquatting-project');
        queryClient.invalidateQueries('users-me');
      }
    }
  )
}
